// extracted by mini-css-extract-plugin
export default {"root":"SettingPush_root__dyTkM","tip":"SettingPush_tip__RVJF2"};